const videoEmbed = {
    init: function () {
        const playButtons = document.querySelectorAll(".js-play-button");
        playButtons.forEach((btn) => btn.addEventListener("click", triggerVideo));

        function triggerVideo() {
            const container = this.closest(".js-video-player");
            let autoplayString = container.classList.contains("js-player-23") ? "&autoPlay=1" : "&autoplay=1";
            let videoFrame = container.querySelector(".video-frame");
            videoFrame.src += autoplayString;
            videoFrame.classList.add("show");
            container.querySelector('.video-overlay').classList.add("fade-out");
            if(container.classList.contains("js-video-collage-video")) {
                container.closest(".video-collage__video-wrapper").classList.add("playing");
            }
        }
    }
}

export default videoEmbed;